(() => {
  document.querySelectorAll('input[type="radio"]').forEach(radio => {
    radio.addEventListener('change', () => {
      console.log(radio);
      const radioGroup = document.querySelectorAll(`input[name="${radio.name}"]`);
      radioGroup.forEach(input => {
        input.setAttribute('aria-checked', input.checked ? 'true' : 'false');
      });
    });
  });
}) ()